export const maskEmail = (email: string) =>
	email.replace(
		/^(...)(.*)(@.*)$/,
		(_, a, b, c) => a + b.replace(/./g, '*') + c
	);

export const fuzzySearch = (str: string | undefined, wordlist: string) => {
	if (!str) return false;
	const splittedStr = str.toLowerCase();
	const words = wordlist.toLowerCase().split(/\s+/);
	return words.every((itm) => splittedStr.includes(itm));
};

export const fuzzyInList = (lst: string[] | undefined, wordlist: string) =>
	lst?.some((w) => fuzzySearch(w, wordlist)) || false;
